export const Logo = () => {
  return <div className="text-lg font-bold text-black/70 leading-none">DXRating.net</div>
}
